import React from 'react'
import { withIcon } from '../../withIcon'

function ChevronRightIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.44703 5.35025C8.69898 5.0983 9.10747 5.0983 9.35942 5.35025L15.553 11.5438C15.8049 11.7957 15.8049 12.2042 15.553 12.4562L9.35942 18.6497C9.10747 18.9017 8.69898 18.9017 8.44703 18.6497C8.19508 18.3978 8.19508 17.9893 8.44703 17.7373L14.1844 12L8.44703 6.26264C8.19508 6.01069 8.19508 5.6022 8.44703 5.35025Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ChevronRightIcon)
